import { useState } from 'react';
import './NewSubClient.css';
import { generate } from 'generate-password-browser';
import { subClientAccessOptions } from '../../utilities/services/clientOptions';
import { createSubClient } from '../../utilities/api/subClients';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';

const defaultFormData = {
    type: 'viewer',
    email: '',
    password: '',
};

export default function NewSubClient({user, client, subClients, updateSubClients, toggleNotifications}) {
    const passwordLength = 12;
    const [formData, setFormData] = useState(defaultFormData);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (evt) => {
        setFormData({
            ...formData,
            [evt.target.name]: evt.target.value,
        });
    }

    const generatePassword = () => {
        const password = generate({
            length: passwordLength,
            numbers: true,
        });
        setFormData({
            ...formData,
            password: password,
        });
    }

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        if (formData.email.trim() === client.companyEmail) {
            toggleNotifications('error', 'This email is already in use by this client', '#FFFFFF');
            formNotificationStyle2('formNotificationContainer', 'This email is already in use by this client', 'red', 1);
        } else {
            try {
                setIsSubmitting(true);
                const response = await createSubClient(user._id, client._id, formData);
                setFormData(defaultFormData);
                const newSubClients = [...subClients, response].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                await updateSubClients(newSubClients);
                toggleNotifications('success', 'Credentials created successfully!', '#FFFFFF');
                formNotificationStyle2('formNotificationContainer', 'Credentials created successfully!', 'green', 1);
            } catch (error) {
                console.error('Error creating credentials:', error);
                toggleNotifications('error', 'This email may already be in use by this client', '#FFFFFF');
                formNotificationStyle2('formNotificationContainer', 'This email may already be in use by this client', 'red', 1);
            } finally {
                setIsSubmitting(false);
            }
        }
    }

    const disabled = !formData.email || !formData.password || formData.password.length < passwordLength;

  return (
    <div className='NewSubClient'>
        <form onSubmit={handleSubmit} id='NewSubClientForm'>
            <div className='form-group mb-2'>
                <label htmlFor="type" className='form-label'>Access Type:</label>
                <select className='form-select' name="type" id="type" value={formData.type} onChange={handleChange}>
                    {subClientAccessOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>
            <div className='form-group mb-2'>
                <label htmlFor="email" className='form-label'>Email:</label>
                <input type="email" className='form-control' name="email" id="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className='form-group'>
                <label htmlFor="password" className='form-label'>Password:</label>
                <input type="text" className='form-control' name="password" id="password" value={formData.password} onChange={handleChange} required />
            </div>
            { (formData.password && formData.password.length < passwordLength) && 
            <small className="errorText">&nbsp;Must be at least {passwordLength} characters long!</small>
            }
            <button type="button" className='generatePassword' onClick={generatePassword}>
                Generate Password
            </button>
        </form>
        <div className='buttonContainer'>
            <button type="submit" form='NewSubClientForm' className='createCredentials' disabled={disabled||isSubmitting}>Create Access Credentials</button>
        </div>
        <div id='formNotificationContainer' className='text-center'></div>
    </div>
  )
}
